import LayoutPages from "@/layout/Layout2";

const ROUTES = [
  {
    path: "/volunteering/coordinador-imagen",
    component: LayoutPages,
    children: [
      {
        path: "list",
        component: () => import("@/views/volunteering/ListVoluntariadoCoordinadorImagens"),
      },
      {
        path: "add",
        component: () => import("@/views/volunteering/AddEditVoluntariadoCoordinadorImagen"),
      },
      {
        path: "edit/:id",
        component: () => import("@/views/volunteering/AddEditVoluntariadoCoordinadorImagen"),
      },
      {
        path: "detail/:id",
        component: () => import("@/views/volunteering/VoluntariadoCoordinadorImagenDetail"),
      },
    ],
  },
];

export default ROUTES;
